import { filterClasses } from "@swivl-mono/helpers"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { memo } from "react";
import "./Checkbox.scss";

type Outlets = "wrapper" | "checkbox" | "label";

interface CheckboxProps {
  classNames?: { [Key in Outlets]?: string };
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  isThemed?: boolean;
  label?: string;
  name?: string;
  onCheckedChange?: (checked: CheckboxPrimitive.CheckedState) => void;
}

const BaseCheckbox = ({
  checked,
  classNames = {},
  defaultChecked = false,
  disabled = false,
  isThemed = false,
  label,
  name = "checkbox",
  onCheckedChange
}: CheckboxProps) => {
  const internalClassNames = {
    wrapper: filterClasses("flex gap-2 items-center Checkbox", disabled && "is-disabled", isThemed && "is-themed", classNames.wrapper),
    checkbox: filterClasses(
      "flex items-center size-5 rounded-[3px] transition-colors border justify-center checkbox-root",
      classNames.checkbox
    ),
    label: filterClasses("checkbox-label flex-1 text-left", classNames.label)
  }

  return (
    <div className={internalClassNames.wrapper} aria-disabled={disabled}>
      <CheckboxPrimitive.Root
        checked={checked}
        className={internalClassNames.checkbox}
        defaultChecked={defaultChecked}
        disabled={disabled}
        id={name}
        name={name}
        onCheckedChange={onCheckedChange}
      />
      {label && (
        <label className={internalClassNames.label} aria-disabled={disabled} htmlFor={name} style={{ margin: 0 }}>{label}</label>
      )}
    </div>
  )
}

export const Checkbox = memo(BaseCheckbox);
